// NOMBASE - Not Found Screen
import React from 'react';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const NotFound = ({ title, description }) => {
  return (
    <div 
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4"
      data-testid="not-found"
    >
      <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center mb-6">
        <FileQuestion className="w-8 h-8 text-muted-foreground" />
      </div>
      <h1 className="text-2xl font-semibold mb-2">{title || 'Page Not Found'}</h1>
      <p className="text-muted-foreground max-w-md mb-8">
        {description || 'The page you are looking for does not exist or has been moved.'}
      </p>
      <Button asChild>
        <Link to="/" data-testid="back-to-dashboard">
          Return to Dashboard
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
